import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/corpdrivee/_sidebar-layout/supports')({
    onEnter: () => {
        document.title = 'CorpDrivee - Помощь'
    },
})
